module.exports = __webpack_public_path__ + "static/media/address.97cd6ca5.svg";